import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 9C2.25 3.75 3.75069 2.25 9.00034 2.25C14.25 2.25 15.75 3.75 15.75 9C15.75 14.25 14.1923 15.75 9.00034 15.75C3.80838 15.75 2.25 14.25 2.25 9Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12V6",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12V9.75",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12L6 8.25",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChartBox);
export { ForwardRef as ReactComponent };
